import { PipelineResponse } from "components/TalentPools/TalentPoolsMain";
import { httpApi } from "./http.api";

export const getPipelineData = (): Promise<any[]> =>
  httpApi.get<any[]>("hiring/pipeline/").then((data: any) => data.data);

export const deletePipeline = async (id: number): Promise<any> => {
  return httpApi.delete<any>(`hiring/pipeline/${id}/`, {});
};
export const deletePipelines = (pipelineIds: any): Promise<any> =>
  httpApi
    .post<any>("hiring/delete-pipelines/", {
      pipelines: pipelineIds ? pipelineIds : [],
    })
    .then(({ data }) => data);

export const addPipeline = (pipelinePayload: any): Promise<any> =>
  httpApi.post<any>("hiring/pipeline/", { ...pipelinePayload }).then(({ data }) => data);

export const importCandidateToPipeline = (pipelinePayload: any): Promise<any> =>
  httpApi
    .post<any>("hiring/custom-assignment/import-candidate-to-job/", {
      ...pipelinePayload,
    })
    .then(({ data }) => data);

export const getPipeline = (id: number): Promise<PipelineResponse> =>
  httpApi.get<any[]>("hiring/pipeline/" + id + "/").then((data: any) => data.data);

export const updatePipeline = (pipelineId: any, pipelinePayload: any): Promise<any> => {
  delete pipelinePayload.id;
  return httpApi
    .put<any>("hiring/pipeline/" + pipelineId + "/", { ...pipelinePayload })
    .then(({ data }) => data);
};

export const addCandidateToPipeline = (pipelinePayload: any): Promise<any> => {
  if (!pipelinePayload.search_id) {
    delete pipelinePayload.search_id;
  }
  return httpApi
    .post<any>("hiring/custom-pipeline/add-candidate-to-pipeline/", {
      ...pipelinePayload,
    })
    .then(({ data }) => data);
};

export const downLoadShortListCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates-for-pipeline/shortlisted-candidates/" + id + "/")
    .then(({ data }) => data);

export const downLoadImportedCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates-for-pipeline/imported-candidates/" + id + "/")
    .then(({ data }) => data);

export const pipelineListOfCandidate = (candidate_id: number): Promise<any> =>
  httpApi
    .post<any>("hiring/custom-pipeline/get-pipelines-for-candidate/", {
      candidate_id,
    })
    .then(({ data }) => data);

//{{base_url}}/hiring/custom-pipeline/reject-candidate-from-pipeline/
/**
 * {
    "pipelines": [400, 401],
    "candidates": [2577, 2569],
    "is_rejected": true
}
 */

// export const rejectCandidateFromPipeline = (payload: any): Promise<any> =>
//   httpApi
//     .post<any>("hiring/custom-pipeline/reject-candidate-from-pipeline/", {
//       ...payload,
//     })
//     .then(({ data }) => data);

export const rejectCandidateFromJob = (payload: any): Promise<any> =>
  httpApi
    .post<any>("hiring/reject-candidate/reject-candidate-for-job/", {
      candidates: [...payload.candidates],
      jobs: [...payload.jobs],
      is_rejected: true,
      search_log_id: payload?.search_log_id,
    })
    .then(({ data }) => data);
